import React from 'react';
import { Typography, Button, withStyles } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import LogoConcilia from '../../../componentes/LogoConcilia';
import PapperBlock from '../../../componentes/PapperBlock/PapperBlock';
import Decoration from '../../Templates/Decoration';
import styles from '../../Templates/appStyles-jss';
import SnackMessage from '../../../componentes/SnakBar';

interface Props {
  classes: any;
}

const ValidateCodePage: React.FC<Props> = ({ classes }) => {
  const location = useLocation();
  const [exists, setExists] = React.useState<boolean | null>(null);
  const [snack, setSnack] = React.useState<{
    message: string;
    messageVariant: 'success' | 'warning' | 'info' | 'error';
    messageOpen: boolean;
  }>({ message: '', messageVariant: 'info', messageOpen: false });

  const code = React.useMemo(
      () => new URLSearchParams(location.search).get('code')?.trim() || '',
      [location.search]
  );

  React.useEffect(() => {
    if (code) {
      setExists(true);
    } else {
      setExists(false);
      setSnack({ message: 'Código não informado', messageVariant: 'warning', messageOpen: true });
    }
  }, [code]);

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setSnack({ message: 'Código copiado para a área de transferência!', messageVariant: 'success', messageOpen: true });
    }).catch(() => {
      setSnack({ message: 'Falha ao copiar código', messageVariant: 'error', messageOpen: true });
    });
  };

  const closeMessage = () => setSnack(sn => ({ ...sn, messageOpen: false }));

  return (
      <main className={classNames(classes.content, classes.contentPaddingLeft)} id="mainContent">
        <Decoration mode="light" gradient="true" decoration="true" bgPosition="full" horizontalMenu={false} />
        <section className={classNames(classes.mainWrap, classes.sidebarLayout)}>
          <LogoConcilia classe="toplogo_sistema" right />
          <div className={classes.pageTitle}>
            <Typography component="h4" className={classes.lightTitle} variant="h4">
              Identificação de Código
            </Typography>
          </div>
          <PapperBlock title="Resultado">
              {exists === true && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="h5" style={{ marginRight: 16 }}>Código: {code}</Typography>
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<FileCopyIcon />}
                        onClick={handleCopy}
                    >
                      Copiar
                    </Button>
                  </div>
              )}
              {exists === false && <Typography variant="h6">Código não encontrado.</Typography>}
          </PapperBlock>
          <SnackMessage
              message={snack.message}
              variant={snack.messageVariant}
              open={snack.messageOpen}
              close={closeMessage}
          />
        </section>
      </main>
  );
};

export default withStyles(styles as any)(ValidateCodePage);
